import { cn } from '@sohanemon/utils';
import type { ComponentProps } from 'react';

import { ThemedLottie } from './themed-lottie';

const ASTRONAUT_MOON_COLOR_SLOTS = {
	'astronaut-ink': '--foreground',
	'astronaut-primary': '--primary',
	'astronaut-suit': '--background',
	'astronaut-white': '--card',
	'astronaut-shade': '--muted',
	'astronaut-accent': '--accent',
};

type AstronautMoonLottieProps = ComponentProps<typeof ThemedLottie>;

export function AstronautMoonLottie(props: AstronautMoonLottieProps) {
	const { autoplay = true, loop = true, className, style, ...rest } = props;

	return (
		<ThemedLottie
			src="/lottie/astronaut-moon.lottie"
			loop={loop}
			autoplay={autoplay}
			colorSlotTokens={ASTRONAUT_MOON_COLOR_SLOTS}
			className={cn('mx-auto aspect-square w-full max-w-xl', className)}
			style={style}
			{...rest}
		/>
	);
}
